module.exports = __webpack_public_path__ + "static/media/item-15.57f95f6f.png";